const numbers = {
  gte(itemNumber, comparatorNumber) {
    return itemNumber >= comparatorNumber
  },
  lte(itemNumber, comparatorNumber) {
    return itemNumber <= comparatorNumber
  },
  equal(itemNumber, comparatorNumber) {
    return itemNumber === comparatorNumber
  },
  range(itemNumber, [rangeStart, rangeEnd]) {
    return itemNumber >= rangeStart && itemNumber <= rangeEnd
  },
}

export default numbers
